import Vue from 'vue'
import Vuex from 'vuex'
import {Message, MessageBox} from 'element-ui'
import router from '../router'

Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        //请求的时候loading按钮
        apiType: false,
        //请求错误提示
        errApi: {
            "text": "错误内容",
            "type": false
        },
        //错误弹框
        errBox: {
            "text": "错误内容",
            "type": false
        },
        //tags列表
        keepArr: [],
        // 判tags高亮
        routeName: "",
        // 左侧菜单栏高亮
        // currentMenu:""
    },
    mutations: {
        //添加tags
        arrPush(state, val) {
            // tags列表添加对象，多余多少个就删除第一个，避免太长不好看
            if (state.keepArr.length > 15) {
                state.keepArr.shift();
                state.keepArr.push(val);
            } else {
                state.keepArr.push(val)
            }
        },
        //删除tags
        arrDel(state, val) {
            //最少打开一个页面
            if (state.keepArr.length == 1) {
                Message.error('至少打开一个页面');
                return
            } else {
                state.keepArr.splice(state.keepArr.indexOf(val), 1);
                let last = state.keepArr[state.keepArr.length - 1];
                // 当前页关闭，就默认跳转到最后一个页面
                if (val.name == state.routeName) {
                    router.push({
                        path: last.path,
                        query: last.query,
                        params: last.params
                    })
                }
            }
        },
        //重定义已存在标签
        resetArr(state, val) {
            //最少打开一个页面
            state.keepArr.forEach((i,a)=>{
                if (i.name==val.name) {
                    state.keepArr[a] = val
                }
            })
        },
        //关闭Tags
        shutDownTags(state, val){
            console.log(state, val)
            state.keepArr.splice(state.keepArr.indexOf(val), 1);
        }
    },
    actions: {},
    modules: {}
})
